export default {
  state: {
    list_products: [],
    productMatch: [],
    trendingProducts: [],
    tryProducts: [],
    recentlyBought: [],
    trendingProductsPopup: [],
  },
  mutations: {
    setListProducts(state, data) {
      state.list_products = data;
    },
    product_match(state, { data, merge = false }) {
      if (merge) {
        const deduplicateData = state.productMatch.concat(
          data.filter((newData) => !state.productMatch.find((firstData) => firstData._id == newData._id))
        );
        state.productMatch = deduplicateData;
      } else {
        state.productMatch = data;
      }
    },
    product_trending(state, { data, merge = false }) {
      if (merge) {
        const deduplicateData = state.trendingProducts.concat(
          data.filter((newData) => !state.trendingProducts.find((firstData) => firstData._id == newData._id))
        );
        state.trendingProducts = deduplicateData;
      } else {
        state.trendingProducts = data;
      }
    },
    product_try(state, { data, merge = false }) {
      if (merge) {
        const deduplicateData = state.tryProducts.concat(
          data.filter((newData) => !state.tryProducts.find((firstData) => firstData._id == newData._id))
        );
        state.tryProducts = deduplicateData;
      } else {
        state.tryProducts = data;
      }
    },
    setRecentlyBought(state, data) {
      state.recentlyBought = data;
    },
    setProductTrendingPopup(state, data) {
      state.trendingProductsPopup = data;
    },
  },
  actions: {},
  getters: {},
};
